// extracted by mini-css-extract-plugin
export default {"TextAreaComponent":"TextArea_TextAreaComponent__AfKNq","TextAreaComponent__Styles":"TextArea_TextAreaComponent__Styles__3svSc","label":"TextArea_label__-tiNJ"};